import styled from "styled-components"
import { Container, theme } from "@omnichannel/ace-b2b-elements"
import { APP_ID } from "../../helpers/constants"

const LogoBox = styled.div`
  display: flex;
  justify-content: center;
  /* background-color: #FFF; */
  width: 4rem;
  height: 4rem;
  padding: .4rem;
  border-radius: .2rem;
  align-items: center;
  /* margin-left: .1rem; */
`

const OtherLoginMethodLogo = styled.div`
  display: flex;
  width: 100%;
  margin: 0;
  justify-content: center;
  align-items: center;
`

const OtherLoginMethodLabel = styled(Container)`
  font-weight: ${props => props.disabled ? "400" : "500"};
  font-size: ${props => props.disabled ? "1.2rem" : "1.6rem"};
  display: flex;
  justify-content: flex-end;
  /* width: ${props => props.type === "FACEBOOK" ? "7.8rem" : props.disabled ? "8rem" : "6.4rem"};
  @media (min-width: 384px) {
    width: ${props => props.type === "FACEBOOK" ? "8.6rem" : props.disabled ? "9rem" : "7.4rem"};
  }
  @media (min-width: 411px) {
    width: ${props => props.type === "FACEBOOK" ? "9.4rem" : props.disabled ? "10rem" : "8rem"};
  } */
`

const OtherLoginMethodsText = styled.div`
  font-size: 1.4rem;
  font-weight: 600;
  height: 1.4rem;
`

const ForgotPasswordMsg = styled.div`
  font-size: 1.2rem;
  font-style: italic;
  cursor: pointer;
  color: #3F5F8B;
  font-weight: 500;
`

const VerificationCodeMsg = styled.div`
  font-size: 1.2rem;
  padding: 0.6rem 0 0 0;
  color: ${theme.default.black80P};
`
const VerifyAccountViewMessageContainer = styled.div`
  font-size: 1.5rem;
  color: ${theme.default.black80P};
`

const ResendVerificationCodeLinkButton = styled.a`
  color: ${theme.default.primary};
  font-size: 1.2rem;
  cursor: pointer;
`
const AcceptPolicyCheckBox = styled.div`
  font-size: 1.2rem;
  display: inline-block;
  color: ${theme.default.black80P};
`

const RecaptchaBox = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`

export {
  OtherLoginMethodsText,
  ForgotPasswordMsg,
  VerificationCodeMsg,
  OtherLoginMethodLogo,
  OtherLoginMethodLabel,
  VerifyAccountViewMessageContainer,
  ResendVerificationCodeLinkButton,
  AcceptPolicyCheckBox,
  RecaptchaBox,
  LogoBox
}
